import { useState } from 'react'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { RegisterModal } from '@components/registration/RegisterModal'

export function CTABand() {
  const [showRegister, setShowRegister] = useState(false)

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <div className="relative overflow-hidden rounded-2xl border border-dash-border bg-dash-surface px-6 py-14 text-center sm:px-12">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(70%_80%_at_50%_0%,rgba(139,92,246,0.16),transparent_70%)]"
        />
        <div className="relative">
          <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-dash-text sm:text-4xl">
            Start matching names in minutes
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-dash-secondary">
            Register for a free token and put the pipeline to work across your data sources.
          </p>
          <button
            type="button"
            onClick={() => setShowRegister(true)}
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-dash-accent to-dash-accent-2 px-6 py-3 text-base font-semibold text-white shadow-sm transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-dash-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dash-surface"
          >
            Get API key
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>

      {showRegister && <RegisterModal onClose={() => setShowRegister(false)} redirectTo="/admin" />}
    </section>
  )
}
